import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import SemiModal from "../semi-modal";
import Button from "../button";
import loadable from "@loadable/component";
const Lottie = loadable(() => import("react-lottie"), {ssr: false});
import Loader from "./lottie-files/loader.json";

const DEFAULT_LOTTIE_OPTIONS = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
};

const PostInspectionDiyAuctionModal = ({
    showAuctionProcessHandler
}) => {
    return (
        <SemiModal>
            <div styleName={"styles.modalWrapperContent"}>
                <h3>See how Auction works!</h3>
                <div styleName={"styles.videoStepsWrapper"}>
                    <Lottie options={ DEFAULT_LOTTIE_OPTIONS } height={"290px"} width={"310px"} />
                </div>
                <div styleName={"styles.ctaWrapper"}>
                    <Button
                        text={"OK! GOT IT"}
                        onClick={ showAuctionProcessHandler }/>
                </div>
            </div>
        </SemiModal>

    );
};

PostInspectionDiyAuctionModal.propTypes = {
    showAuctionProcessHandler: PropTypes.func
};

export default PostInspectionDiyAuctionModal;

